import { type Column } from '@tanstack/react-table';

export const getStickyCellStyles = <TData = unknown>(
  column: Column<TData, unknown>,
): React.CSSProperties => {
  const isPinned = column?.getIsPinned();

  if (!isPinned) {
    return { position: 'relative' };
  }

  let right: number | undefined;
  let left: number | undefined;

  if (isPinned === 'right') {
    const leafColumns = column.getLeafColumns();
    const lastLeaf = leafColumns[leafColumns.length - 1];
    right = lastLeaf?.getAfter('right') ?? column.getAfter('right');
  }

  if (isPinned === 'left') {
    const leafColumns = column.getLeafColumns();
    const firstLeaf = leafColumns[0];
    left = firstLeaf?.getStart('left') ?? column.getStart('left');
  }

  return {
    position: 'sticky',
    left: isPinned === 'left' ? `${left}px` : undefined,
    right: isPinned === 'right' ? `${right}px` : undefined,
  } as const;
};

export const getPinnedEdgeDataAttribute = <TData = unknown>(
  column?: Column<TData, unknown>,
) => {
  if (!column) return false;

  const leafColumns = column.getLeafColumns();
  const lastLeaf = leafColumns[leafColumns.length - 1];
  const firstLeaf = leafColumns[0];

  // Check if the rightmost leaf of this column is the last left-pinned column
  if (lastLeaf?.getIsLastColumn('left')) return 'left';

  // Check if the leftmost leaf of this column is the first right-pinned column
  if (firstLeaf?.getIsFirstColumn('right')) return 'right';

  return false;
};

export const getPinnedDataAttribute = <TData = unknown>(
  column?: Column<TData, unknown>,
) => {
  return !!column?.getIsPinned();
};

export const getPinnedSideDataAttribute = <TData = unknown>(
  column?: Column<TData, unknown>,
) => {
  return column?.getIsPinned() || false;
};
